import {useLayoutEffect, useRef} from 'react';

export const WORKSPACE_HISTORY_KEYS_FETCH_STARTED_MARK =
  'workspace_history_keys_fetch_started';
export const WORKSPACE_HISTORY_KEYS_FRESH_RESULT_READY_MARK =
  'workspace_history_keys_fresh_result_ready';
export const WORKSPACE_PANEL_SYNC_STARTED_MARK = 'workspace_panel_sync_started';
export const WORKSPACE_PANEL_SPECS_READY_MARK = 'workspace_panel_specs_ready';
export const WORKSPACE_PANEL_SYNC_COMPLETED_MARK =
  'workspace_panel_sync_completed';

export const WORKSPACE_SYNC_MARK_NAMES = [
  WORKSPACE_HISTORY_KEYS_FETCH_STARTED_MARK,
  WORKSPACE_HISTORY_KEYS_FRESH_RESULT_READY_MARK,
  WORKSPACE_PANEL_SYNC_STARTED_MARK,
  WORKSPACE_PANEL_SPECS_READY_MARK,
  WORKSPACE_PANEL_SYNC_COMPLETED_MARK,
] as const;

// Apollo's setVariables status identifies query-input changes without counting
// initial loading, polling, or generic refetches. The ready mark is emitted only
// after fresh data is available; missing ready marks and repeated starts remain
// visible to the workflow observer as ambiguous observations.
export function useHistoryKeyFetchPerformanceMarks({
  fetchKey,
  isFetchingUpdate,
  hasFreshResult,
}: {
  fetchKey: unknown;
  isFetchingUpdate: boolean;
  hasFreshResult: boolean;
}): void {
  const fetchInProgress = useRef(false);
  const activeFetchKey = useRef<unknown>(undefined);

  useLayoutEffect(() => {
    if (isFetchingUpdate) {
      if (!fetchInProgress.current || activeFetchKey.current !== fetchKey) {
        fetchInProgress.current = true;
        activeFetchKey.current = fetchKey;
        performance.mark(WORKSPACE_HISTORY_KEYS_FETCH_STARTED_MARK);
      }
      return;
    }

    if (!fetchInProgress.current) {
      return;
    }

    fetchInProgress.current = false;
    activeFetchKey.current = undefined;
    if (hasFreshResult) {
      performance.mark(WORKSPACE_HISTORY_KEYS_FRESH_RESULT_READY_MARK);
    }
  }, [fetchKey, hasFreshResult, isFetchingUpdate]);
}
